var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0625C0 6.99473 3.30723 3.6875 7.375 3.6875H51.625C55.6928 3.6875 59 6.99473 59 11.0625V47.9375C59 52.0053 55.6928 55.3125 51.625 55.3125H7.375C3.30723 55.3125 0 52.0053 0 47.9375V11.0625ZM7.375 18.4375V47.9375H25.8125V18.4375H7.375ZM51.625 18.4375H33.1875V47.9375H51.625V18.4375Z",
    fill: "#233C7E",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBig);
export default __webpack_public_path__ + "static/media/dashboardBig.1817669171f015e3e81da038aa10e8b8.svg";
export { ForwardRef as ReactComponent };